import React, { Component } from "react";
import Storage from "../../services/storage.service";
import Translations from "../../services/translation.service";
import HeaderNavigation from "./header-navigation.component";
import Settings from "../../services/settings.service";
import MenuDropdownCloseIcon from "../../assets/img/MenuDropdown.svg";
import MenuDropDownIcon from "../../assets/img/MenuDropDownClose.svg";
import ModernHamIcon from "../../assets/img/ModernHam.svg";
import logo from '../../assets/img/VM_logo.svg';
import User from "../../services/user.service";
import DownloadMenuButton from "./download-menu-button.component";
import DownloadlinkButton from "../../views/shared/download-link-button"
import checkModule from "./checkModule";
import Helpers from "../../helpers/shared.helper";
class StorefrontHeader extends Component {
    state = {
        expanded: false,
        menu: false,
        menus: null,
        expanded_parent: null,
        sub: null,
        super_sub: null,
        join_now: true
    };

    subscriptions = [];
    componentWillUnmount() {
        if (this.subscriptions) {
            for (let subscription of this.subscriptions) {
                subscription.unsubscribe();
            }
        }
    }

    componentDidMount() {
        this.subscriptions.push(
            Translations.getKeysObsrv().subscribe(data => {
                this.forceUpdate();
            })
        );

        this.subscriptions.push(
            Storage.get_obsrv("flags").subscribe(data => {
                if (data?.choose_topup_category) {
                    this.setState({
                        join_now: true
                    })
                } else {
                    this.setState({
                        join_now: false
                    })
                }
            })
        );

        this.subscriptions.push(
            Storage.get_obsrv("menus").subscribe(data => {
                this.setState({
                    menus: typeof data === 'string' ? JSON.parse(data) : data
                });
            })
        );
    }

    menuToggle = () => {
        this.setState({
            menu: !this.state.menu
        });
    }

    loadTopup = () => {
        Storage.clear("session");
        localStorage.clear();
        Storage.set("is_web_category_selected", true, true);
        Storage.set("choose_topup_category", true, true);
        this.setState({
            join_now: true
        })
        window.location.href = "/join/";
    }

    loadJoinNow = () => {
        Storage.clear("session");
        localStorage.clear();
        this.setState({
            join_now: false
        })
        window.location.href = "/join/";
    }

    checkStorage = () => {
        Storage.get_obsrv("flags").subscribe(data => {
            if (data?.NumberSelected === false && data?.PlanSelected === false) {
                User.clearAll()
            }
        })
    }

    featureEnableQuickTopup = () => {
        return Helpers.checkEnableTopup("feature_enable_quick_topup");
    }

    findSubcategories(parentId, lang) {
        if (!lang && !this.state.menus) return;
        if (this.state?.menus?.[lang]) {
            return this.state?.menus?.[lang]
                .filter((item) => item.parent === parentId)
                .map((item) => {
                    const subCategory = {
                        ID: item.ID.toString(),
                        url: item.url,
                        title: item.title,
                        parent: item.parent.toString(),
                    };
                    const subSubCategories = this.findSubcategories(item.ID, lang);
                    if (subSubCategories.length > 0) {
                        subCategory.subSubCategory = subSubCategories;
                    }
                    return subCategory;
                });
        }
        return;
    }

    handleSubCategoryClick(item) {
        if (item.ID === 91033) {
            localStorage.setItem("advertisement_redirect", true);
            localStorage.setItem("advertisement_redirect_url", "https://uat.virginmobile.sa/join/#/advertisement");
            localStorage.setItem("advertisement_step", true);
        }
        if (item.ID === 91032) {
            localStorage.setItem("protection_channel_redirect", true);
            localStorage.setItem("protection_channel_redirect_url", Settings?.footer?.protection_channel);
            localStorage.setItem("protection_channel_step", true);
        }
    }
    createRecreatedObject(lang) {
        if (!lang && !this.state.menus) return;
        if (this.state?.menus?.[lang]) {
            return this.state?.menus?.[lang]
                .filter((item) => item.parent === 0)
                .map((item) => {
                    const category = {
                        ID: item.ID.toString(),
                        url: item.url,
                        title: item.title,
                        parent: item.parent.toString(),
                    };
                    const subcategories = this.findSubcategories(item.ID, lang);
                    if (subcategories.length > 0) {
                        category.subcategory = subcategories;
                    }
                    return category;
                });
        }
        return;
    }

    createMyMenu(menuData) {
        if (!menuData) return null;
        return <>
            {menuData.map((item, index) => {
                return <li className={item.subcategory ? "storefront-parent-menu has-sub-menu" : "storefront-parent-menu"} key={index}>
                    {item.subcategory ? <span onClick={() => {
                        if (this.state.sub === item.ID) {
                            this.setState({
                                sub: null
                            });
                        } else {
                            this.setState({
                                sub: item.ID
                            });
                        }
                    }}
                        className={this.state.sub === item.ID ? "active-sub-menu" : "inactive-sub-menu"}
                    >{item.title} <img src={MenuDropdownCloseIcon} alt="" /></span> : <a href={item.url}>{item.title}</a>}
                    {item.subcategory &&
                        <ul className={`storefront-sub-menu-container ${this.state.sub === item.ID ? "show-on-mob" : "hide-on-mob"}`}>
                            {item.subcategory.map((subItem, index) => {
                                return <li className={subItem.subSubCategory ? "storefront-sub-menu has-super-sub-menu" : "storefront-sub-menu"} key={`sub-${index}`}>
                                    {subItem.subSubCategory ? <span onClick={() => {
                                        if (this.state.super_sub === subItem.ID) {
                                            this.setState({
                                                super_sub: null
                                            });
                                        } else {
                                            this.setState({
                                                super_sub: subItem.ID
                                            });
                                        }
                                    }} className={this.state.super_sub === subItem.ID ? "active-super-sub-menu" : "inactive-super-sub-menu"}>{subItem.title} <img src={this.state.super_sub === subItem.ID ? MenuDropDownIcon : MenuDropdownCloseIcon} alt="" /></span> : <a href={subItem.url}>{subItem.title}</a>}
                                    {subItem.subSubCategory && this.state.super_sub === subItem.ID &&
                                        <ul className="storefront-super-sub-menu-container" data-id={subItem.ID} >
                                            {subItem.subSubCategory.map((subSubItem, index) => {
                                                return <li key={`subSub-${index}`}>
                                                    {checkModule.isHeaderKsa ? <a onClick={() => this.handleSubCategoryClick(subItem)} href={subItem.url}>{subItem.title}</a> : null}
                                                    {checkModule.isHeaderKw ? <a href={subSubItem.url}>{subSubItem.title}</a> : null}
                                                </li>
                                            })}
                                        </ul>
                                    }
                                </li>
                            })}
                        </ul>
                    }
                </li>
            })}
        </>;
    }

    render() {
        let lang = Translations.getCurrentLanguage();
        let other = Translations.getTheOtherLanguage();
        let name = Translations.getLanguageNativeName(other);
        let language_switcher = (
            <li
                className="storefront-language"
            >
                <span
                    onClick={() => {
                        Translations.changeLanguage(other);
                    }}
                >
                    {name}
                </span>
            </li>
        );

        return (
            <>
                <div className="storefront-header-container">
                    <HeaderNavigation
                        menu={this.createMyMenu(this.createRecreatedObject(lang))}
                        lang={language_switcher}
                        activeLang={lang}
                        loadTopup={this.loadTopup}
                        join_now={this.state.join_now}
                        loadJoinNow={this.loadJoinNow}
                    />
                </div>
                <div className="storefront-header-mob-container">
                    <div className="storefront-header-mob">
                        <a onClick={() => { this.checkStorage() }}
                            href={Settings.get('site_link') + lang + "/"}
                            className="main-logo">
                            <img src={logo} alt="Virgin Mobile KSA" />
                        </a>
                        {checkModule.isHeaderKw ? <DownloadlinkButton /> : null}
                        <img src={ModernHamIcon} alt="" onClick={this.menuToggle} />
                    </div>
                    {this.state.menu &&
                        <div className="storefront-header-mob-links">
                            <ul>
                                {this.createMyMenu(this.createRecreatedObject(lang))}
                                {this.featureEnableQuickTopup() ?
                                <>
                                    {this.state.join_now ?
                                        <li className="storefront-join-now">
                                            <span onClick={() => {
                                                this.menuToggle();
                                                this.loadJoinNow();
                                            }}>
                                                {Translations.keys['stm_header_join_now'] || "Join Now"}
                                            </span>
                                        </li> :
                                        <li className="storefront-join-now">
                                            <span onClick={() => {
                                                this.menuToggle();
                                                this.loadTopup();
                                            }}>
                                                {Translations.keys['stm_header_quick_topup'] || "Quick Top-Up"}
                                            </span>
                                        </li>
                                    }
                                </> : ""}
                                {checkModule.isHeaderKw ? <DownloadMenuButton /> : null}
                                {language_switcher}
                            </ul>
                        </div>}
                </div>
            </>
        );
    }
}

export default StorefrontHeader;